"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isManaPurchase = exports.isNFTPurchase = exports.purchaseEventsChannel = void 0;
const redux_saga_1 = require("redux-saga");
exports.purchaseEventsChannel = (0, redux_saga_1.channel)();
function isNFTPurchase(purchase) {
    return 'nft' in purchase;
}
exports.isNFTPurchase = isNFTPurchase;
function isManaPurchase(purchase) {
    return !isNFTPurchase(purchase);
}
exports.isManaPurchase = isManaPurchase;
//# sourceMappingURL=utils.js.map